const formInteractions = () => {

  // https://zellwk.com/blog/check-empty-input-js/

  const inputs = document.querySelectorAll('input, textarea');

  inputs.forEach(input => {

    input.addEventListener('input', evt => {

      const value = input.value;

      if (value) {
        input.dataset.value = 'has-value'
      } else {
        input.dataset.value = ''
        return
      }
    })

  });

}

export default formInteractions;